import { InputAdornment, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { validDecimalAndLength } from '../../ModificationsUtils';

export const AmountPerMile = () => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const { t } = useTranslation();
  const nameAmountPerMile = 'amountPerMile';
  const amountPerMile: number = useWatch({ name: nameAmountPerMile });
  const isModEdit = useSelector(selectIsEditMod);
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);

  useEffect(() => {
    if (getValues(nameAmountPerMile)) {
      clearErrors(nameAmountPerMile);
    } else {
      setError(nameAmountPerMile, {});
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={nameAmountPerMile}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(nameAmountPerMile) ?? ''}
          variant="filled"
          label={t('placement.placementMods.amountPerMile')}
          fullWidth
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 3 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(nameAmountPerMile, validInput, { shouldDirty: true });
              onChange(validInput);
              if (validInput) clearErrors(nameAmountPerMile);
            }
          }}
          InputLabelProps={{
            shrink: amountPerMile ? true : false,
          }}
          color="primary"
          autoComplete="off"
          id="amountPerMile"
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
